module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAYAAAAfrhY5AAAA9UlEQVRYCe2XMQqFMBBER/EGItgo4kUEEcEjeS5LsRA8hZVgsLOyUlA/CSjZXpcPJk12NmEfExKWWEKIs65r9H0PrhFFEdI0hS3B27ZxcRVn33dUVQWH0/HlcBxHFTpXQs6+7yNJEsRxrKcfiSWw6zoMw3DXs+8IeA0sGUEQIM9zHQcCf8OxTnNdV5cUTlYYBHHOwCMIAyfHwSXIsU/T9Cp3WRZSn8DbtsU8z2TDU0KCm6Yh5ayyLE+SYRTEOSNXob4LN11NXQDT1bie3Hef2v84N13tE7fdCcMQx3FACMFlGJ7nqf+hnWUZ1nVlA0uQ/JgWRYEfngll26D8nWwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common-icons/horizontal-split.png
// module id = CRjL
// module chunks = 1